import { overview_routes_group } from './overview';
import { verification_routes_group } from './verification';

export const dashboard_routes_group = [
	...overview_routes_group,
	...verification_routes_group,
	
  
];
